// ─── Tooltip texts for deep insights metrics ────────────────────────
// Single source of truth for every metric explanation shown via the
// info-icon tooltip across the deep insights dashboard.

/** Engagement level badges (per-investor). */
export const ENGAGEMENT_TOOLTIPS: Record<string, string> = {
  summary_only: 'Viewed the profile summary only. No sections expanded, no reactions.',
  quick_scan: 'Briefly scanned the profile. Fewer than 3 sections expanded, under 2 minutes total.',
  engaged: 'Actively explored the profile. Expanded 3+ sections or left reactions on statements.',
  deep_dive:
    'Thoroughly reviewed the profile. Re-expanded sections, spent significant time reading, or reacted to 3+ statements.',
}

/** Decision stage badges (per-investor). */
export const DECISION_STAGE_TOOLTIPS: Record<string, string> = {
  screening: 'First visit, only viewed the summary. Early-stage filtering.',
  active_evaluation: 'Multiple visits or deeper engagement. Actively assessing the opportunity.',
  comparing: '3+ visits with 3–7 day gaps between sessions. Likely comparing with other startups.',
  serious_interest:
    '2+ visits with deep-dive engagement on the latest session. Strong signal of interest.',
}

/** Top-level stat cards. Keyed by the stat label (case-insensitive match). */
export const STAT_TOOLTIPS: Record<string, string> = {
  'Total Views': 'Total number of profile views across all active share links.',
  'Unique Visitors': 'Number of distinct investors who viewed your profile.',
  'Avg. Time': 'Average time each visitor spent actively viewing your profile.',
  'Sections Viewed': 'Number of distinct profile sections viewed across all visitors.',
}

/** Aggregates panel metrics. */
export const AGGREGATE_TOOLTIPS: Record<string, string> = {
  'Return Rate': 'Percentage of visitors who came back for a second or subsequent visit.',
  'Avg. Session': 'Average duration of a single viewing session.',
  'Avg. Expansions': 'Average number of profile sections expanded per visitor.',
}

/** Profile Perception sub-sections. */
export const PERCEPTION_TOOLTIPS: Record<string, string> = {
  Dimensions:
    'How investors perceive each area of your profile (Team, Traction, Market, Problem/Solution, and Vision), based on how much time they spend and what they click on.',
  'Investor Risk Concerns':
    'Which risks investors pay attention to. High concern means investors spent time reading it. Low concern means they skipped over it.',
}

/** AI report section headings. */
export const AI_SECTION_TOOLTIPS: Record<string, string> = {
  'Profile Strengths & Weaknesses':
    'AI analysis of how investors perceive each dimension of your profile (Team, Traction, Market, etc.) based on time spent, expansions, and reactions.',
  'Risk Perception':
    'How investors engage with the risks identified in your evaluation: which risks draw the most attention and how deeply they explore them.',
  'Content Effectiveness':
    'How investors interact with your uploaded documents: which pages they view, where they spend the most time, and where they drop off.',
  'Investor Behavior Patterns':
    'Aggregate behavioral signals across all investor sessions: average session length, expansion patterns, return visit rates, and common navigation flows.',
}
